import { useIsInstaller } from 'src/auth/hooks/useIsInstaller';
import { useAbility } from 'permissions/hooks/useAbility';
import { Actions, Subjects } from 'src/permissions/ability';

export const useTariffSummaryAvailable = () => {
  const abilty = useAbility();
  const isInstaler = useIsInstaller();
  return (
    abilty.can(Actions.read, Subjects.tariffSummary) &&
    !isInstaler
  );
};
